import { yupResolver } from '@hookform/resolvers/yup';

import * as yup from 'yup';

import { RemindPassFields } from './types';

import { EMAIL_MAX_LENGTH, EMAIL_PATTERN } from '../../../lib/constants';
import { STATIC_ERROR_PHRASES } from '../../AuthCheckEmail/constants';

const remindPassFormValidationSchema: yup.ObjectSchema<RemindPassFields> = yup
    .object({
        email: yup
            .string()
            .max(EMAIL_MAX_LENGTH, STATIC_ERROR_PHRASES.EMAIL_MAX_LENGTH_ERROR)
            .required()
            .matches(EMAIL_PATTERN, STATIC_ERROR_PHRASES.EMAIL_ERROR),
    })
    .required();

export const remindPassResolver = yupResolver(remindPassFormValidationSchema);
